export const AGREEMENTS = {
  TITLE: 'Agreements',
  DOWNLOAD: 'Download',
  DESCRIPTION: 'Please attach the following documents:',
  ADD_DOCUMENTS: 'Add documents',
  ADD_AND_SUBMIT: 'Add and submit',
  ADD_THE_FOLLOWING_DOCUMENTATION: 'Add the following documentation',
  CLICK_TO_UPLOAD: 'Click to upload',
  OR_DRAG_AND_DROP: 'or drag & drop',
  UPLOAD_GUIDE: 'Upload guide:',
  FILE_FORMATS: 'File formats: jpg, .jpeg, .png, .pdf',
  UPLOAD_LIMIT: 'Upload limit: max. 35 MB',
}

export const DOCUMENT_CONTROL_MODAL_TITLE = {
  add: 'Add documents',
  replace: 'Replace documents',
}

export const DOCUMENT_LIST: Record<string, string> = {
  Agreement: 'Agreement',
  RegistrationCertificate: 'Certificate of Registration',
  SignatureAuthority: 'List of Authorized Signatories',
  PassportOrIdCard: 'Passport/ID card of Representative',
}

export const REPLACE = 'Add to replace'
